import { SaleTag, Tooltip } from '@cencosud-cencommerce/paris-uikit';

interface SoldByProps {
  saleTagProps: {
    label: string;
    storeName: string;
  };
  soldTooltip?: {
    title: string;
    text: string;
  };
}

export const SoldBy = (props: SoldByProps) => {
  if (!props.saleTagProps) return null;

  const { title, text } = props.soldTooltip || {};

  if (text) {
    return (
      <Tooltip title={title} content={text}>
        <SaleTag
          {...props.saleTagProps}
          iconRight="info-circle"
          className="co-break-all"
        />
      </Tooltip>
    );
  }

  return <SaleTag {...props.saleTagProps} className="co-break-all" />;
};

SoldBy.displayName = 'SoldBy';

export default SoldBy;
